export default "__VITE_ASSET__51c1b12e__"